<template>
    <vx-selectable v-model="model"
        placeholder="Search Phone Pool"
        :loading="loading"
        :options="options"
        @search="search"
        data-test="phone-number-pool-selectable">
    </vx-selectable>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { phoneNumberPoolsClient } from '~/services';
import debounce from '~/utils/debounce';

const teamId = Spark.state.currentTeam.id;
const toasted = useToasted();

const model = defineModel();

const options = ref([]);
const loading = ref();

const search = debounce((query) => {
    loading.value = true;

    phoneNumberPoolsClient.getList(teamId, {
        search: query,
    }).then((response) => {
        options.value = response.data.data.map((pool) => ({
            value: pool.id,
            label: pool.friendly_name
        }))
    }).catch((e) => {
        console.error(e)
        toasted.global.platform_error()
    }).finally(() => {
        loading.value = false
    })
}, 300);

search();
</script>
